import axios from 'axios';
import store from '@/store';
import config from "@/config";

const instance = axios.create({
    baseURL: config.baseURLApi,
});

instance.interceptors.request.use(function (config){
    if(!config.headers['Content-Type']){
        config.headers['Content-Type'] = "application/json";
    }
    const token = localStorage.getItem('token');
    if (token) {
        config.headers['Authorization'] = "Bearer " + token;
    }
    return config;
});

instance.interceptors.response.use( response => {
    return response;
}, error => {
    if(error.response.status === 401 && error.config.silence401 !== true){
        store.dispatch('auth/logoutUser');
    }
    if(error.response.status === 403 && error.response.data.state){
        if('acl_work_space_denied' === error.response.data.state){
            setTimeout(() => {
                store.dispatch('notifications/SHOW_RESPONSE_ERROR', {errorResponse: error, defaultError: 'Ошибка: доступ к пространству ограничен'});
            }, 1000);
            store.dispatch('workspace/CHECKOUT_OTHER_WORKSPACE');
        }
    }
    return Promise.reject(error);
});

export default instance;